import type { IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';
import type { IUpdateChallengeClipRequest } from './update-challenge-clip-request';
import type { IUpdateChallengeClipResponse } from './update-challenge-clip-response';
import { updateChallengeClipResponseSchema } from './update-challenge-clip-response';

export async function updateChallengeClipApi({
  challengeId,
  clipId,
  body,
}: IUpdateChallengeClipRequest): Promise<IValidatedResponse<IUpdateChallengeClipResponse>> {
  return putRequest<IUpdateChallengeClipResponse>({
    path: `/sys/challenges/${challengeId}/clips/${clipId}`,
    body,
    schema: updateChallengeClipResponseSchema,
  });
}
